import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import UserCard from 'flarum/forum/components/UserCard';

const rankClasses: Record<string, string> = {
    'Brand New': 'brand-new',
    'Newbie': 'newbie',
    'Jr. Member': 'jr-member',
    'Member': 'member',
    'Full Member': 'full-member',
    'Sr. Member': 'sr-member',
    'Hero Member': 'hero-member',
    'Legendary': 'legendary',
};

export function addRankBadge() {
    // Add rank badge next to username on posts
    extend(CommentPost.prototype, 'headerItems', function (items) {
        const post = this.attrs.post;
        if (!post || !post.user()) return;

        const user = post.user();
        const rank = user.attribute('meritRank') || 'Brand New';
        const cssClass = rankClasses[rank] || 'brand-new';

        items.add('merit-rank', (
            <span className={'merit-rank-badge merit-rank-badge--' + cssClass}>
                {rank}
            </span>
        ), 10);
    });

    // Add rank info to user card
    extend(UserCard.prototype, 'infoItems', function (items) {
        const user = this.attrs.user;
        if (!user) return;

        const rank = user.attribute('meritRank') || 'Brand New';
        const activity = user.attribute('meritActivity') || 0;
        const totalMerit = user.attribute('totalMeritReceived') || 0;
        const cssClass = rankClasses[rank] || 'brand-new';

        items.add('merit-rank-info', (
            <span className="merit-rank-info">
                <span className={'merit-rank-badge merit-rank-badge--' + cssClass}>
                    {rank}
                </span>
                <span className="merit-activity">
                    Activity: {activity} | Merit: {totalMerit}
                </span>
            </span>
        ), 80);
    });
}
